<template>
<div>
    <b-modal ref="modal" title="Consulta NF-e" header-class="border-bottom-0" size="lg" no-close-on-backdrop>

        <div class="card mb-4">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <h5 class="text-primary">
                            <i class="fas fa-file-invoice" /> Eventos da NF-e
                        </h5>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <small class="text-muted">Código do Status:</small>
                    </div>
                    <div class="col-md-8">{{ request.cStat }}</div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <small class="text-muted">Data de Envio:</small>
                    </div>
                    <div class="col-md-8">{{ request.dhRecbto | dateTimeBr}}</div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <small class="text-muted">Evento da NF-e:</small>
                    </div>
                    <div class="col-md-8">{{ request.xMotivo}}</div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <small class="text-muted">Chave da NF-e:</small>
                    </div>
                    <div class="col-md-8">{{ request.chNFe}}</div>
                </div>
                <br />
            </div>
        </div>
        <table-paginator :data="event" @pagechange="consultEventsInDatabase($event)">
            <div class="row grid-table-heading">
                <div class="col-md-1-5 text-center">cStat</div>
                <div class="col-8 order-2 col-md-3 order-md-2 mb-3 mb-md-0">Motivo</div>
                <div class="col-1 order-5 col-md-2 order-md-5 align-rigth text-md-center text-primary">Natureza</div>
                <div class="col-2 order-3 col-md-3 order-md-3 align-rigth text-md-center text-primary">NSU</div>
            </div>
            <hr />

            <template v-for="row in event.data">
                <div class="row grid-table-row" :key="row.id">
                    <div class="col-md-1-5 text-center">{{ row.cStat }}#</div>
                    <div class="col-8 order-2 col-md-3 order-md-2 mb-3 mb-md-0">{{row.xMotivo}}</div>
                    <div class="col-1 order-5 col-md-2 order-md-5 align-rigth text-md-center text-primary">{{row.description}}</div>
                    <div class="col-2 order-3 col-md-3 order-md-3 align-rigth text-md-center text-primary">{{row.nSeqEvento}}</div>
                </div>
            </template>
        </table-paginator>
    </b-modal>
</div>
</template>

<script>
import TablePaginator from './../../sections/TablePaginator.vue';

export default {
    components: {
        TablePaginator
    },

    data: function () {
        return {
            request: {},

            status_cstat: {},

            status_date: {},

            status_description: {},

            status_protocol: {},

            event: {}
        };
    },

    methods: {
        open(id = null) {

            this.consultNfeSefaz(id);

            this.$refs.modal.show();

            this.consultEventsInDatabase(id);
        },

        consultNfeSefaz(id) {
            this.$store.commit("showLoading");

            axios
                .post("api/nfe/consult/" + id)
                .then(response => {
                    this.request = response.data;

                    this.status_cstat.value = response.data.protNFe.infProt.cStat;
                    this.status_date.value = response.data.protNFe.infProt.dhRecbto;
                    this.status_description.value = response.data.protNFe.infProt.xMotivo;
                    this.status_protocol.value = response.data.protNFe.infProt.nProt;
                    this.$store.commit("hideLoading");
                    this.$emit("stored");

                })
                .catch(error => {
                    this.error = error;
                    this.$store.commit("hideLoading");
                });
        },

        consultEventsInDatabase(id) {

            axios
                .post("api/nfe/selectevents/" + id)
                .then(response => {

                    this.event = response.data;
                    this.$emit("stored");

                })
                .catch(error => {
                    this.error = error;
                    this.$store.commit("hideLoading");
                });
        },

    }
};
</script>

<style>
</style>
